// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>
import { CoinbaseWalletSDK } from './CoinbaseWalletSDK.js';
export default CoinbaseWalletSDK;
export { CoinbaseWalletSDK } from './CoinbaseWalletSDK.js';
export { createCoinbaseWalletSDK } from './createCoinbaseWalletSDK.js';
//# sourceMappingURL=index.js.map